var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "free-paid-chart", class: { fullscreen: _vm.fullScreen } },
    [
      _c("HalfPieChart", {
        attrs: {
          series: _vm.getSeries(),
          colors: ["#cb5d0f", "#4213ce", "#c9d906"],
        },
      }),
      _vm._v(" "),
      _vm.tableMode
        ? _c("TableView", {
            attrs: { cols: _vm.getCols(), rows: _vm.getRows() },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "stats" },
        [
          _c("StatCard", {
            attrs: {
              title: "Total Free",
              value: _vm.stats.freePlanSiteCount,
              unit: "site",
            },
          }),
          _vm._v(" "),
          _c("StatCard", {
            attrs: {
              title: "Total Paid",
              value: _vm.stats.paidPlanSiteCount,
              unit: "site",
            },
          }),
          _vm._v(" "),
          _c("StatCard", {
            attrs: {
              title: "Total Trial",
              value: _vm.stats.trialPlanSiteCount,
              unit: "site",
            },
          }),
          _vm._v(" "),
          _c("StatCard", {
            attrs: {
              title: "Total Suspend",
              value: _vm.stats.suspendSiteCount,
              unit: "site",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }